'use client'
import React from 'react'
import { TailSpin } from "react-loader-spinner";
import { Box } from '@mui/material';
export interface LoadingSpinnerProps {
    height?: string;
    width?: string;
}
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ height = '40', width = '40' }) => {
    return (
        <Box component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 8px 15px 8px' }}>
            <TailSpin
                visible={true}
                height={height}
                width={width}
                color="#FE6526"
                ariaLabel="tail-spin-loading"
                radius="1"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </Box>
    )
}
export default LoadingSpinner